module.exports = __webpack_public_path__ + "img/reward.bb3d9872.png";